export default {"src":"/_next/static/media/arrow_tale_right.6e323fd2.svg","height":26,"width":26,"blurWidth":0,"blurHeight":0};